import Avatar from '../../../../../avatar';
import { AvatarProps } from '../../../../../avatar';
import React from 'react';
import classNames from 'classnames';
import { clsPrefix } from '../../card-header.styled';

const CardHeaderAvatar = ({ className, ...rest }: AvatarProps) => {
  return (
    <Avatar className={classNames(className, `${clsPrefix}-avatar`)} {...rest} size="Xsmall" />
  );
};

export default CardHeaderAvatar;
